import { clsx } from 'clsx'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  label?: string
}

const sizes = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-10 h-10' }
const borders = { sm: 'border-2', md: 'border-2', lg: 'border-[3px]' }

export default function LoadingSpinner({ size = 'md', className, label = 'Loading…' }: Props) {
  return (
    <span
      role="status"
      aria-label={label}
      className={clsx(
        sizes[size],
        borders[size],
        'rounded-full border-blue/30 border-t-blue animate-spin inline-block shrink-0',
        className,
      )}
    />
  )
}

// Route-level loading lives in components/ui/PageLoader.tsx (skeleton frame).
